<template>
  <v-container class="fill-height with-fancy-bg">
    <v-row align="center" class="fill-height" justify="center">
      <v-col>
        <v-card class="mx-auto" max-width="688px">
          <div class="right-language-switcher">
            <LanguageSwitcher />
          </div>
          <v-card-title class="text-center mt-10 auth-forms-top-title">
            <span class="text-primary">{{
              $t("views.newPassword.NewPassword")
            }}</span>
          </v-card-title>
          <v-card-subtitle v-if="errorMessage" class="auth-forms-sub-title text-center text-red">
            {{ $t("actions.error-message", { message: errorMessage }) }}
          </v-card-subtitle>
          <v-card-subtitle v-else class="auth-forms-sub-title text-center">
            {{ $t("views.newPassword.NewPasswordDescription") }}
          </v-card-subtitle>

          <v-card-text>
            <v-form v-model="valid">
              <v-form v-model="valid">
                <v-text-field v-model="password" :append-inner-icon="!showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  autocomplete="current-password" data-cy="new-password" class="mb-2" clearable density="default"
                  :label="$t('entities.user.fields.password')" :persistent-placeholder="false" :rules="passwordRules"
                  :type="showPassword ? 'input' : 'password'" @click:append-inner="showPassword = !showPassword" />
                <v-text-field v-model="repeatPassword" :append-inner-icon="!showRepeatPassword ? 'mdi-eye-off' : 'mdi-eye'
                  " autocomplete="current-password" data-cy="new-password-repeat" class="mb-6" clearable
                  density="default" :label="$t('entities.user.fields.password_confirmation')"
                  :persistent-placeholder="false" :rules="[...passwordRules, ...repeatPasswordRules]"
                  :type="showRepeatPassword ? 'input' : 'password'" variant="outlined" @click:append-inner="
                    showRepeatPassword = !showRepeatPassword
                    " />

                <v-row class="mt-">
                  <v-col class="text-center">
                    <v-btn block class="text-none text-subtitle-1" color="primary"
                      :disabled="!valid || !submitButtonEnabled" prepend-icon="mdi-check" rounded="xl" size="large"
                      variant="flat" data-cy="new-password-submit" @click="submit">
                      {{ $t("actions.submit") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useTranslation } from "i18next-vue";

import LanguageSwitcher from "../../components/tools/LanguageSwitcher.vue";
import { useUserRules } from "../../validations/user.js";
import { useAuthStore } from "@/stores/authStore";

const authStore = useAuthStore();

const { t } = useTranslation();
const router = useRouter();
const route = useRoute();

const valid = ref(true);

const password = ref("");
const repeatPassword = ref("");
const showPassword = ref(false);
const showRepeatPassword = ref(false);
const errorMessage = ref(null);
const submitButtonEnabled = ref(true);

const { passwordRules } = useUserRules(t);

const repeatPasswordRules = ref([
  (v) => v === password.value || t("validations.passwords-dont-match")
]);

function submit() {
  submitButtonEnabled.value = false;
  errorMessage.value = null;
  authStore
    .setPassword(route.query.token, password.value, repeatPassword.value)
    .then(({ data }) => {
      if (!data) {
        errorMessage.value = t("validations.unknown-error");
      } else {
        router.push({ name: "thank-you", params: { action: "new-password" } });
      }
    })
    .catch((error) => {
      errorMessage.value = error.response.data;
      console.log(errorMessage);
    })
    .finally(() => {
      submitButtonEnabled.value = true;
    });
}
</script>
